Postlogin = (function (self) {
    self.UsersList = {};
    const me = self.UsersList;

    const reportResultsTable = $('#report-results-table');
    const userViewUrl = reportResultsTable.data('user-view-url');
    const userEditUrl = reportResultsTable.data('user-edit-url');
    const exportUrl = $('#export-user-list').data('export-url');
    // const userLogoutUrl = reportResultsTable.data('user-logout-url');
    const userDeleteUrl = reportResultsTable.data('user-delete-url');
    const tableHeight = window.innerHeight * 0.85;

    // bulk edit stuffs
    const bulkDeleteMax = 500;
    let selections = [];
    let bulkDeleteButtons;
    let bulkDeleteEnableButton;
    let bulkDeleteDeleteButton;
    let bulkDeleteCancelButton;

    me.reportsTableOptions = {
        formatNoMatches() {
            return 'No users to show';
        },
        method: 'post',
        contentType: 'application/x-www-form-urlencoded',
        classes: 'table table-hover table-condensed',
        height: tableHeight,
        striped: true,
        showRefresh: true,
        showToggle: false,
        showColumns: true,
        showPaginationSwitch: false,
        minimumCountColumns: '2',
        pagination: true,
        search: false,
        toolbar: '#report-toolbar',
        toolbarAlign: 'right',
        searchAlign: 'left',
        clickToSelect: true,
        maintainSelected: false,
        sidePagination: 'server',
        sortName: 'date_last_activity',
        sortOrder: 'desc',
        idField: 'user_id',
        url: Slim.Router.urlFor('Users.search'),
        pageSize: 25,
        queryParamsType: 'other',
        queryParams(params) {
            return {
                ...params,
                username: document.getElementById('search-user-name').value,
                first_name: document.getElementById('search-first-name').value,
                last_name: document.getElementById('search-last-name').value,
                unique_identifier: document.getElementById('search-unique-identifier').value,
                license_id: [...document.querySelectorAll('#user-license-ids option')]
                    .filter((opt) => opt.selected)
                    .map((license) => license.value),
                user_type: [...document.querySelectorAll('#user-types option')]
                    .filter((opt) => opt.selected)
                    .map((userType) => userType.value),
                group_ids: [...document.querySelectorAll('#user-groups option')].filter((opt) => opt.selected).map((group) => group.value),
                grade: [...document.querySelectorAll('#user-grades option')].filter((opt) => opt.selected).map((grade) => grade.value),
                date: document.getElementById('search-date').value,
                date_range_from: document.getElementById('search-start-date').value,
                date_range_to: document.getElementById('search-end-date').value,
                active: document.getElementById('search-active').value,
                logged_in: document.getElementById('search-logged-in').value,
            };
        },
        columns: [
            [
                {
                    field: 'checkbox',
                    title: 'Delete',
                    checkbox: true,
                    visible: false,
                    rowspan: 2,
                    formatter(value, row) {
                        if (
                            row.is_active === 0
                            // if im a teacher, only can delete students...
                            || (Jr.getCurrentUserRoleId() === 3 && row.role_id > 2)
                            // if im a school admin, can only delete school admins and below
                            || (Jr.getCurrentUserRoleId() > 3 && row.role_id > Jr.getCurrentUserRoleId())
                            // cannot delete self
                            || Jr.getCurrentUserId() === row.user_id
                        ) {
                            return {
                                disabled: true,
                            };
                        }

                        return $.inArray(row.user_id, selections) !== -1;
                    },
                },
                {
                    title: 'Role',
                    field: 'role_id',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    formatter(value, row) {
                        let classes;

                        switch (value) {
                            case 2:
                                classes = 'fa-child';
                                break;
                            case 3: // teacher
                                classes = 'fa-user text-success';
                                break;
                            case 4: // school admin
                                classes = 'fa-user text-info';
                                break;
                            case 5: // district admin
                                classes = 'fa-user text-warning';
                                break;
                            case 6: // vjs admin
                                classes = 'fa-user text-danger';
                                break;
                            case 7:
                                classes = 'fa-laptop';
                                break;
                            default:
                                classes = 'fa-user';
                                break;
                        }

                        return `<i class="fa ${classes}" aria-hidden="true"></i>${row.role}`;
                    },
                },
                {
                    title: 'Username',
                    field: 'username',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    formatter(value, row) {
                        const url = userViewUrl.replace(':user_id', row.user_id);

                        return `<a href="${url}">${value}</a>`;
                    },
                },
                {
                    title: 'Unique ID',
                    field: 'unique_identifier',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    visible: false,
                },
                {
                    title: 'First Name',
                    field: 'first_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    formatter(value, row) {
                        const url = userViewUrl.replace(':user_id', row.user_id);

                        return `<a href="${url}">${value}</a>`;
                    },
                },
                {
                    title: 'Last Name',
                    field: 'last_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    formatter(value, row) {
                        const url = userViewUrl.replace(':user_id', row.user_id);

                        return `<a href="${url}">${value}</a>`;
                    },
                },
                {
                    title: 'Email',
                    field: 'email',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    visible: false,
                },
                {
                    title: 'Grade',
                    field: 'grade',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    visible: false,
                    formatter: (row) => {
                        if (parseInt(row, 10) === 0) {
                            return 'K';
                        }
                        if (parseInt(row, 10) === -1) {
                            return 'PK';
                        }
                        return row;
                    },
                },
                {
                    title: 'Rostering Type',
                    field: 'rostering_type',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    visible: false,
                },
                {
                    title: 'Rostering ID',
                    field: 'rostering_id',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    visible: false,
                },
                {
                    title: 'Grad Year',
                    field: 'graduation_year',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    visible: false,
                },
                {
                    title: 'Created',
                    field: 'date_created',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    formatter(value) {
                        return Jr.Utils.convertDate(value, 'llll');
                    },
                },
                {
                    title: 'Last Activity',
                    field: 'date_last_activity',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    sorter: Jr.Utils.dateSorter,
                    rowspan: 2,
                    formatter(value) {
                        return Jr.Utils.convertDate(value, 'llll');
                    },
                },
                {
                    title: 'School(s)',
                    field: 'license_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                },
                {
                    title: 'District',
                    field: 'district_name',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    rowspan: 2,
                    visible: false,
                },
                {
                    title: 'Logins',
                    field: 'past_sessions_count',
                    align: 'center',
                    valign: 'middle',
                    sortable: true,
                },
                {
                    title: 'Time Spent',
                    field: 'time_spent',
                    align: 'left',
                    valign: 'middle',
                    sortable: true,
                    formatter(value) {
                        if (value === 0) return '-';

                        const duration = moment.duration(value * 1000);
                        return `<span title="${Math.round(duration.asMinutes())} minutes">${duration.humanize()}</span>`;
                    },
                },
                {
                    title: '',
                    field: 'actions',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    rowspan: 2,
                    switchable: false,
                    formatter(value, row) {
                        const editUrl = userEditUrl.replace(':user_id', row.user_id);
                        const deleteUrl = userDeleteUrl.replace(':user_id', row.user_id);

                        let editAction = '';
                        if (row.can_manage === 1 && row.sso_user_id == null) {
                            editAction = `<a href="${editUrl}" class="btn btn-hollow-blue">Edit</a>`;
                        }

                        let manageAction = '';
                        if (row.is_active === 1 && row.can_manage === 1 && row.sso_user_id == null) {
                            manageAction = `
                                <form action="${deleteUrl}" method="post" class="delete-entry">
                                    <input type="hidden" name="csrf_token" value="${Jr.getCsrfToken()}">
                                    <input type="hidden" name="_METHOD" value="DELETE" />
                                    <button type="submit" class="btn btn-hollow-pink">Delete</button>
                                </form>
                            `;
                        }

                        return `${editAction}${manageAction}`;
                    },
                },
            ],
            [
                {
                    title: 'Date Range',
                    field: 'date_range',
                    align: 'center',
                    valign: 'middle',
                    sortable: false,
                    colspan: 2,
                    class: 'date-range-header',
                },
            ],
        ],
        responseHandler(res) {
            const results = {};
            results.total = res.meta.total;
            results.rows = res.data;
            results.duration = res.meta.duration;

            if ($('#search-date option:selected').val() === 'custom') {
                $('#report-results-table th.date-range-header').text(`
                    ${$('#search-start-date').val()} to ${$('#search-end-date').val()}
                `);
            } else {
                $('#report-results-table th.date-range-header').text($('#search-date option:selected').text());
            }

            return results;
        },

        onLoadSuccess(data) {
            $('time.timeago').timeago();
            reportResultsTable.removeClass('sorting');
            reportResultsTable.closest('.bootstrap-table').find('.pagination-detail .duration').remove();
            reportResultsTable
                .closest('.bootstrap-table')
                .find('.pagination-detail')
                .append(
                    `
                    <span class="duration">&nbsp;&nbsp;&nbsp;<em>(query took ${data.duration.toFixed(4)} seconds)</em></span>
                `,
                );

            $('body').css('cursor', 'default');
            $('.app').removeClass('light-blur');
            $('#ajax-progress-indicator').fadeOut();
        },

        rowStyle(row) {
            let classes = '';
            if (row.sessions.length > 0) {
                classes += 'success ';
            }
            if (row.is_active === 0) {
                classes += 'danger ';
            }

            return {
                classes,
            };
        },
        onSort() {
            // when sorting, grey out the table contents until the results are back
            reportResultsTable.addClass('sorting');
            $('body').css('cursor', 'progress');
        },
    };

    // Shared Tom Select config for the 4 filter-bar multi-selects.
    // Ported from bootstrap-select's .selectpicker() on 2026-05-11 as
    // prep for the Bootstrap 5 upgrade. Behavior preserved:
    //   - Multi-select (inherited from <select multiple> in Twig).
    //   - Live search with diacritic-insensitive matching.
    //   - Placeholder text when nothing is selected.
    // Behavior changed (deliberate, minor):
    //   - bootstrap-select collapsed >2 selections to "N Widgets
    //     selected". Tom Select shows all chips (with an x to remove
    //     each). This is more discoverable; if product feedback wants
    //     the collapse back, use Tom Select's `hideSelected` plugin
    //     with a custom render.
    //   - The FA check icons (iconBase/tickIcon) were cosmetic and
    //     are dropped; Tom Select's default selected visual suffices.
    const initFilterSelect = (selector, placeholder) => {
        const el = document.querySelector(selector);
        if (!el) return;
        // eslint-disable-next-line no-new
        new TomSelect(el, {
            placeholder,
            plugins: ['remove_button'],
            diacritics: true,
            maxOptions: null,
        });
    };

    me.initEvents = function () {
        initFilterSelect('#user-license-ids', 'All licenses selected');
        initFilterSelect('#user-types', 'Any User Role');
        initFilterSelect('#user-groups', 'No groups selected');
        initFilterSelect('#user-grades', 'Choose Grade(s)');

        const reportForm = $('#report-form');
        reportForm.on('change', '#search-date', () => {
            const value = $('#search-date option:selected').val();
            if (value === 'custom') {
                $('#search-start-date').val(moment().subtract(14, 'days').format('YYYY-MM-DD'));
                $('#search-end-date').val(moment().format('YYYY-MM-DD'));

                $('#report-form .date-container.hide').removeClass('hide');
            } else {
                $('#report-form .date-container').addClass('hide');
            }
        });

        reportForm.on('submit', (event) => {
            event.preventDefault();
            reportResultsTable.addClass('sorting');
            $('body').css('cursor', 'progress');
            reportResultsTable.bootstrapTable('destroy');
            reportResultsTable.bootstrapTable(me.reportsTableOptions);
            me.setupBulkDeleteUsers();

            return false;
        });

        $('#result-list-container').on('click', '#export-user-list', (event) => {
            event.preventDefault();

            me.exportReport();
        });

        if (reportResultsTable.data('initialize')) {
            reportResultsTable.bootstrapTable(me.reportsTableOptions);
        }

        const currentDate = new Date(new Date().setHours(23, 59, 59));
        const dateOptions = {
            restrictions: {
                maxDate: currentDate,
            },
            display: {
                theme: 'light',
                components: {
                    clock: false,
                },
            },
        };
        new tempusDominus.TempusDominus(document.getElementById('search-start-date'), {
            ...dateOptions,
            container: document.getElementById('start-date-container'),
        });

        new tempusDominus.TempusDominus(document.getElementById('search-end-date'), {
            ...dateOptions,
            container: document.getElementById('end-date-container'),
        });
    };

    me.exportReport = function () {
        const opts = $('#report-results-table').bootstrapTable('getOptions');
        const columns = $('#report-results-table').bootstrapTable('getVisibleColumns');

        const exportParams = me.getReportParams({
            columns: [...columns.map((field) => [field.title, field.field])],
            offset: 0,
            limit: 5000,
            sortName: opts.sortName,
            sortOrder: opts.sortOrder,
            timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        });

        const queryString = $.param(exportParams);
        window.open(`${exportUrl}?${queryString}`, '_blank');
    };

    me.getReportParams = function (params) {
        const exportParams = {
            ...params,
            username: document.getElementById('search-user-name').value,
            first_name: document.getElementById('search-first-name').value,
            last_name: document.getElementById('search-last-name').value,
            unique_identifier: document.getElementById('search-unique-identifier').value,
            license_id: [...document.querySelectorAll('#user-license-ids option')]
                .filter((opt) => opt.selected)
                .map((license) => license.value),
            user_type: [...document.querySelectorAll('#user-types option')].filter((opt) => opt.selected).map((userType) => userType.value),
            group_ids: [...document.querySelectorAll('#user-groups option')].filter((opt) => opt.selected).map((group) => group.value),
            grade: [...document.querySelectorAll('#user-grades option')].filter((opt) => opt.selected).map((grade) => grade.value),
            date: document.getElementById('search-date').value,
            date_range_from: document.getElementById('search-start-date').value,
            date_range_to: document.getElementById('search-end-date').value,
            active: document.getElementById('search-active').value,
            logged_in: document.getElementById('search-logged-in').value,
        };

        return exportParams;
    };

    me.setupBulkDeleteUsers = function () {
        bulkDeleteButtons = $('<div id="bulk-delete-buttons" class="pull-left"></div>');
        bulkDeleteEnableButton = $(
            '<button id="bulk-delete-enable-btn" '
                + 'class="btn btn-hollow-pink" type="button" name="refresh" '
                + 'aria-label="refresh" title="Enable Bulk Delete Mode">'
                + '<i class="fa-regular fa-square-check" aria-hidden="true"></i> Enable Bulk Delete Mode'
                + '</button>',
        );
        bulkDeleteDeleteButton = $(
            '<button id="bulk-delete-delete-btn" '
                + 'class="btn btn-hollow-pink" type="button" name="refresh" '
                + 'aria-label="refresh" data-toggle="tooltip" '
                + 'data-placement="top" title="Select Users to Bulk Delete, then click here to delete them" '
                + 'style="display:none;">'
                + 'Bulk Delete <span class="selected-users-count">0 Users</span></button>',
        );
        bulkDeleteCancelButton = $(
            '<button id="bulk-delete-cancel-btn" '
                + 'class="btn btn-hollow-dark-gray" type="button" '
                + 'name="refresh" aria-label="refresh" title="Cancel" style="display:none;">'
                + 'Cancel</button>',
        );
        bulkDeleteEnableButton.on('click', me.enableBulkDeleteMode);
        bulkDeleteCancelButton.on('click', me.disableBulkDeleteMode);

        // when they click on the bulk edit button, show the modal
        bulkDeleteDeleteButton.on('click', () => {
            if (selections.length > 0) {
                me.updateSelectedUsersCount();
                bulkDeleteDeleteButton.tooltip('hide');
                // actually do the deletin'
                $('body').css('cursor', 'wait');
                $('.app').addClass('light-blur');
                $('#ajax-progress-indicator').fadeIn();

                const data = {};
                data.user_ids = selections;

                $.ajax({
                    url: '/users/',
                    dataType: 'json',
                    method: 'DELETE',
                    data,
                    async: true,
                }).always(() => {
                    selections = [];
                    me.updateSelectedUsersCount();
                    me.disableBulkDeleteMode();
                    reportResultsTable.bootstrapTable('refresh', { silent: true });
                });

                bulkDeleteDeleteButton.prop('disabled', false);
                me.updateSelectedUsersCount();

                return false;
            }

            return true;
        });

        bulkDeleteButtons.append(bulkDeleteDeleteButton);
        bulkDeleteButtons.append(bulkDeleteEnableButton);
        bulkDeleteButtons.append(bulkDeleteCancelButton);

        reportResultsTable.on('check.bs.table check-all.bs.table uncheck.bs.table uncheck-all.bs.table', (e, rows) => {
            const userIds = $.map(!$.isArray(rows) ? [rows] : rows, (row) => row.user_id);
            if (e.type === 'check' || e.type === 'check-all') {
                if (userIds.length + selections.length > bulkDeleteMax) {
                    window.alert('You have reached the max # of users to bulk delete at one time!');
                    reportResultsTable.bootstrapTable('uncheckBy', { field: 'user_id', values: _.difference(userIds, selections) });

                    return false;
                }
            }
            const func = $.inArray(e.type, ['check', 'check-all']) > -1 ? 'union' : 'difference';
            selections = _[func](selections, userIds);

            return me.updateSelectedUsersCount();
        });

        me.addButtons();
    };

    me.updateSelectedUsersCount = function () {
        $('.selected-users-count').text(`
            ${selections.length} User${selections.length === 1 ? '' : 's'}
        `);
    };

    me.enableBulkDeleteMode = function () {
        me.updateSelectedUsersCount();
        bulkDeleteEnableButton.hide();
        bulkDeleteDeleteButton.show();
        bulkDeleteDeleteButton.tooltip('show');
        bulkDeleteCancelButton.show();
        reportResultsTable.bootstrapTable('showColumn', 'checkbox');
        reportResultsTable.bootstrapTable('hideColumn', 'actions');
    };

    me.disableBulkDeleteMode = function () {
        selections = [];
        reportResultsTable.bootstrapTable('uncheckAll');
        me.updateSelectedUsersCount();
        bulkDeleteEnableButton.show();
        bulkDeleteDeleteButton.hide();
        bulkDeleteCancelButton.hide();
        bulkDeleteDeleteButton.tooltip('hide');
        reportResultsTable.bootstrapTable('hideColumn', 'checkbox');
        reportResultsTable.bootstrapTable('showColumn', 'actions');
    };

    me.addButtons = function () {
        $('#bulk-delete-buttons').remove();
        // .columns is bootstrap-table's own class for its button group and is stable
        // across themes; the BS3 .pull-right it used to match became .float-right in BS4.
        reportResultsTable.closest('.bootstrap-table').find('.fixed-table-toolbar .columns').prepend(bulkDeleteButtons);
        $('[data-toggle="tooltip"]').tooltip();
    };

    me.init = function () {
        me.initEvents();
    };

    return self;
}(Postlogin || {}));
